<template>
  <div v-if="!presentingRightData">
    <div
      class="limit-online-text"
      v-if="$store.state.plan && ($store.state.plan.group == 'pro'
        || $store.state.plan.group == 'white-label')"
    >
      <span
        v-html="$i18nPresenter.t('youCanHostForPro')"
      ></span>
      <a
        href="https://form.typeform.com/to/j2O9GXjI/"
        target="_blank"
        class="ml-1"
      >{{ $i18nPresenter.t('Contact us') }}</a>.
    </div>

    <div
      class="limit-online-text"
      v-if="$store.state.plan.group != 'pro' && !currentUser.oneTimeEnd
        && $store.state.plan.group != 'white-label'
        && !isGuestUser"
    >
      <span v-if="$store.state.plan.group == 'free'">
        <span
          v-html="$i18nPresenter.t('asAFreeUserYouCanHostUpto', {
            x: ($store.state.plan.limit)
          })"
        ></span>
        <span class="cursor-pointer text-primary-90 ml-1" @click="goToUpgrade()">
          {{ $i18nPresenter.t('Upgrade from just $7.95.') }}
        </span>
      </span>
      <span v-else-if="$store.state.plan.group == 'one-time'">
        <span></span>
        <span
          v-html="$i18nPresenter.t('youCanHostUptoOnYourEventday', {
            x: ($store.state.plan.limit)
          })"
        ></span>
        <i
          class="fas fa-question-circle"
          v-tooltip="oneTimeTooltip"
        />&nbsp;
        <span>
          {{ $i18nPresenter.t('Need more?') }}
          <a @click="goToUpgrade()" class="ml-1">{{ $i18nPresenter.t('Upgrade now') }}</a>.
        </span>
      </span>
      <span v-else>
        <span></span>
        <span
          v-html="$i18nPresenter.t('youCanHostUpto', {
            x: ($store.state.plan.limit)
          })"
        ></span>
        <span>
          <a @click="goToUpgrade()" class="ml-1">{{ $i18nPresenter.t('Upgrade now') }}</a>.
        </span>
      </span>
    </div>
    <div
      class="limit-online-text"
      v-if="$store.state.plan.group == 'one-time' && currentUser.oneTimeEnd"
    >
      {{ $i18nPresenter.t('Your event day has started.') }}
      {{ $i18nPresenter.t('You can host up to') }}
      <strong>{{ $store.state.plan.limit | formatNumber }}</strong> {{ $i18nPresenter.t('live participants until') }}
      <strong>{{ currentUser.oneTimeEnd | dateTimeFirst }}</strong>.
      <br>{{ $i18nPresenter.t('Need more?') }}
      <a @click="goToUpgrade()" class="ml-1">{{ $i18nPresenter.t('Upgrade now') }}</a>.
    </div>
    <PlanUpgradeModal
      :openModal="openUpgradeModal"
      @hide="openUpgradeModal = false"
    />
  </div>
  <div v-else>
    <div class="limit-online-text">
      You can host this presentation for <strong>{{ presentingRightData.limit | formatNumber }}</strong> participants
      <aha-icon
        class="ml-1 text-base-70"
        name="question"
        viewBox="0 0 24 24"
        width="15"
        height="15"
        v-tooltip="`Because the presentation owner has <b>${presentingRightData.name}</b> plan`"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgradeModal.vue'
// services
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import cookie from '@/services/cookie'
import featuresByPlan from '@/components-v2/my-plan/user-pricing/featuresByPlan'
import Config from '@/config'
import EventBus from '@/eventBus'

export default {
  components: {
    PlanUpgradeModal,
  },
  data() {
    return {
      openUpgradeModal: false,
      isGuestUser: !!cookie.getValue('aha-guest-user'),
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
      isNewPresentation: (state) => state.isNewPresentation,
      presentingRightData: (state) => state.presentingRightData,

    }),
    ...mapGetters(['isTreatmentPlanUpgradeEditor']),
    oneTimeTooltip() {
      return this.$i18nPresenter.t('Your event day will start when you have more than 7 participants joining your presentation simultaneously and last for 24 hours')
    },
  },
  mounted() {
    // listen event
    EventBus.$on('open-modal-upgrade-to-presenting', () => {
      this.openUpgradeModal = true
    })
  },
  methods: {
    goToUpgrade() {
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Feature upgrade',
        'Middle participant limit',
      )
      if (!this.isTreatmentPlanUpgradeEditor) {
        this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
        return
      }
      // if plan is plus, redirect to pro checkout, not show modal
      if (this.currentUser.plan && (this.currentUser.plan.includes('plus') || this.currentUser.plan.includes('edu-large'))) {
        const urlPro = featuresByPlan.annual.updateLink.find((plan) => plan.permissionKey === 'proYearly').url
        const paramBackLink = `&back_link_to_presentation=${encodeURIComponent(window.location.href)}`
        window.location.href = `${Config.presenterDomain}${urlPro}${paramBackLink}`
        return
      }
      if (this.isTreatmentPlanUpgradeEditor) {
        this.openUpgradeModal = true
      }

      // add redirect to handle case: guest clicks upgrade -> go to sign-up first
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.limit-online-text {
  font-size: 13px;
  text-align: center;
  padding-bottom: 12px;
  color: $suva-grey-color;
  max-width: 680px;
  margin: 0 auto;
  font-family: "Nunito", sans-serif;

  a {
    font-weight: bold;
    cursor: pointer;
    color: $primary-color;

    &:hover {
      color: $primary-hover-color;
      text-decoration: underline;
    }
  }
}
</style>
